module.exports = __webpack_public_path__ + "img/worksbot_img19121108.fd641746.jpg";